/**
 * Inline JS source for capturing Sierra Session AI's `z1_analytic` window event
 * and forwarding it to GA via `dataLayer`. Injected from `pages/_document.tsx`.
 *
 * ModalOrchestrator listens for the same event to drive modal routing, but it
 * mounts only inside the modal subtree of `pages/index.tsx`. This document-level
 * listener gives GA a `z1_analytic_capture` push on every page.
 */

declare global {
  interface Window {
    __z1CaptureInstalled?: boolean;
    dataLayer?: unknown[];
  }
}

const Z1_CAPTURE_SCRIPT = `(function () {
  if (typeof window === 'undefined') return;
  if (window.__z1CaptureInstalled) return;
  window.__z1CaptureInstalled = true;

  window.addEventListener('z1_analytic', function (e) {
    try {
      var detail = (e && e.detail) || {};
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'z1_analytic_capture',
        eppLabel: detail.eppLabel || null,
        score: typeof detail.score === 'number' ? detail.score : null,
        page: window.location.pathname
      });
    } catch (_) {}
  });
})();`;

export default Z1_CAPTURE_SCRIPT;
